import { Link } from "react-router-dom";
import { prefetchRoute } from "@/lib/prefetch";

// Link that warms the destination's code chunk on hover / touch / focus.
export default function PLink({ to, onMouseEnter, onTouchStart, onFocus, ...rest }) {
  const warm = () => prefetchRoute(typeof to === "string" ? to : to?.pathname);
  return (
    <Link to={to} {...rest}
      onMouseEnter={(e) => { warm(); onMouseEnter?.(e); }}
      onTouchStart={(e) => { warm(); onTouchStart?.(e); }}
      onFocus={(e) => { warm(); onFocus?.(e); }} />
  );
}
